import React from "react";

function Hero() {

    return (
        <div className="hero">
            <h1>Dive into the World of Anime:</h1>
            <p>Your Latest Updates and Services Await! Explore News, Reviews, Merchandise, and More.</p>
            <div className="btn btn-primary"><span className="zx">ANIME</span> NEWS</div>
            <div className="btn btn-primary"><span className="zx">MANGA</span> NEWS</div>
        </div>
    )
}
export default Hero